/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestTournamentWithdrawalBody
 */
export interface RequestTournamentWithdrawalBody {
    /**
     * 
     * @type {number}
     * @memberof RequestTournamentWithdrawalBody
     */
    amount?: number;
}

/**
 * Check if a given object implements the RequestTournamentWithdrawalBody interface.
 */
export function instanceOfRequestTournamentWithdrawalBody(value: object): value is RequestTournamentWithdrawalBody {
    return true;
}

export function RequestTournamentWithdrawalBodyFromJSON(json: any): RequestTournamentWithdrawalBody {
    return RequestTournamentWithdrawalBodyFromJSONTyped(json, false);
}

export function RequestTournamentWithdrawalBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestTournamentWithdrawalBody {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function RequestTournamentWithdrawalBodyToJSON(json: any): RequestTournamentWithdrawalBody {
    return RequestTournamentWithdrawalBodyToJSONTyped(json, false);
}

export function RequestTournamentWithdrawalBodyToJSONTyped(value?: RequestTournamentWithdrawalBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
    };
}

